import { inOutDirectiveFactory } from 'vue-in-out/src/in-out-factory.js';


export const hovered = inOutDirectiveFactory({
    inEvent: 'mouseover',
    outEvent: 'mouseout',
    activeClass: 'hovered',
});
